import React from "react";
import smlLogo from "../images/sml_sign_rgb_1024.png";
import kafkaLogo from "../images/kafka-logo.png";
import Image from "antd/lib/image";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Typography from "antd/lib/typography";

const { Title, Paragraph } = Typography;

const Header: React.FC = () => (
    <>
     <Row justify="center">
            <Col span={6}>
                <a
                    href="https://softwaremill.com"
                    target="_blank"
                    rel="noreferrer"
                    title="Created by SoftwareMill"
                >
                    <Image src={smlLogo} alt="SoftwareMill" preview={false} />
                </a>
            </Col>
        </Row>
        <Row justify="center">
            <Title level={1}>Kafka Visualization</Title>
        </Row>
        <Row >
            <Col span={4}>
                <Image src={kafkaLogo} alt="Kafka" preview={false} />
            </Col>
            <Col span={20}>
                <Paragraph>
                        <a
                            href="https://kafka.apache.org"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Apache Kafka
                        </a>{" "}
                        is a distributed event streaming platform. Using the
                        tool below you can simulate how data flows through a
                        replicated Kafka topic, to gain a better understanding
                        of the message processing model.
                    </Paragraph>
            </Col>
        </Row>
    </>
);

export default Header;
